export default __webpack_public_path__ + "static/mazda_blue-961c867607f1a0121e68a632afcb1a52.jpg";